import React from "react";
import PageShell from "../dashboard/PageShell";

interface ResearchPositionSummaryItem {
  id: string;
  stt: number;
  organizationName: string;
  total: number;
  seniorResearcher: number;
  researcher: number;
  researchEngineer: number;
  assistantResearcher: number;
}

const mockData: ResearchPositionSummaryItem[] = [
  {
    id: "1",
    stt: 1,
    organizationName: "Viện Khoa học Thủy lợi Miền Nam",
    total: 0,
    seniorResearcher: 0,
    researcher: 0,
    researchEngineer: 0,
    assistantResearcher: 0,
  },
  {
    id: "2",
    stt: 2,
    organizationName: "Viện Khoa học Thủy lợi Miền Trung và Tây Nguyên",
    total: 0,
    seniorResearcher: 0,
    researcher: 1,
    researchEngineer: 0,
    assistantResearcher: 0,
  },
  {
    id: "3",
    stt: 3,
    organizationName: "Viện Nước, Tưới Tiêu và Môi trường",
    total: 0,
    seniorResearcher: 0,
    researcher: 0,
    researchEngineer: 0,
    assistantResearcher: 0,
  },
  {
    id: "4",
    stt: 4,
    organizationName: "Viện Thủy công",
    total: 0,
    seniorResearcher: 0,
    researcher: 0,
    researchEngineer: 0,
    assistantResearcher: 0,
  },
  {
    id: "5",
    stt: 5,
    organizationName: "Viện Bơm và Thiết bị thủy lợi",
    total: 0,
    seniorResearcher: 0,
    researcher: 0,
    researchEngineer: 1,
    assistantResearcher: 0,
  },
  {
    id: "6",
    stt: 6,
    organizationName: "Viện Thủy điện và năng lượng tái tạo",
    total: 0,
    seniorResearcher: 0,
    researcher: 0,
    researchEngineer: 0,
    assistantResearcher: 0,
  },
  {
    id: "7",
    stt: 7,
    organizationName: "Viện Kinh tế và Quản lý thủy lợi",
    total: 0,
    seniorResearcher: 0,
    researcher: 0,
    researchEngineer: 0,
    assistantResearcher: 0,
  },
  {
    id: "8",
    stt: 8,
    organizationName: "Viện Kỹ thuật Biển",
    total: 0,
    seniorResearcher: 0,
    researcher: 1,
    researchEngineer: 0,
    assistantResearcher: 0,
  },
  {
    id: "9",
    stt: 9,
    organizationName:
      "Phòng Thí nghiệm trọng điểm Quốc gia về động lực học sông biển",
    total: 0,
    seniorResearcher: 0,
    researcher: 0,
    researchEngineer: 0,
    assistantResearcher: 0,
  },
  {
    id: "10",
    stt: 10,
    organizationName: "Trung tâm Đào tạo và Hợp tác Quốc tế",
    total: 0,
    seniorResearcher: 0,
    researcher: 0,
    researchEngineer: 0,
    assistantResearcher: 0,
  },
  {
    id: "11",
    stt: 11,
    organizationName: "Trung tâm phòng thử Môi và sinh vật cỏ hại",
    total: 0,
    seniorResearcher: 0,
    researcher: 0,
    researchEngineer: 0,
    assistantResearcher: 0,
  },
  {
    id: "12",
    stt: 12,
    organizationName: "Trung tâm công nghệ phần mềm thủy lợi",
    total: 0,
    seniorResearcher: 0,
    researcher: 0,
    researchEngineer: 0,
    assistantResearcher: 0,
  },
  {
    id: "13",
    stt: 13,
    organizationName:
      "Trung tâm Tư vấn quản lý thủy nông có sự tham gia của người dân",
    total: 0,
    seniorResearcher: 0,
    researcher: 0,
    researchEngineer: 0,
    assistantResearcher: 0,
  },
];

// Calculate totals
const totals = {
  total: 6,
  seniorResearcher: 1,
  researcher: 4,
  researchEngineer: 1,
  assistantResearcher: 0,
};

const ResearchPositionSummary: React.FC = () => {
  return (
    <PageShell title="Tổng hợp nhân sự theo chức danh nghiên cứu">
      <div className="space-y-6">
        {/* Header Section */}
        <div className="flex justify-between items-center">
          <h1 className="text-xl font-semibold text-gray-800">
            Tổng hợp nhân sự theo chức danh nghiên cứu
          </h1>
        </div>

        {/* Data Table */}
        <div className="bg-white rounded-lg shadow overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th
                    rowSpan={2}
                    className="px-2 py-3 text-center text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-16"
                  >
                    Số TT
                  </th>
                  <th
                    rowSpan={2}
                    className="px-2 py-3 text-center text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-80"
                  >
                    Tên tổ chức nghiên cứu và phát triển
                  </th>
                  <th
                    colSpan={5}
                    className="px-2 py-3 text-center text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200"
                  >
                    Nhân lực hiện có đến thời điểm hiện tại
                  </th>
                </tr>
                <tr>
                  <th className="px-2 py-3 text-center text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-20">
                    Tổng số
                    <br />
                    (4) ÷ (7)
                  </th>
                  <th className="px-2 py-3 text-center text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-32">
                    Nghiên cứu viên cao cấp/
                    <br />
                    Kỹ sư cao cấp
                  </th>
                  <th className="px-2 py-3 text-center text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-32">
                    Nghiên cứu viên chính/
                    <br />
                    Kỹ sư chính
                  </th>
                  <th className="px-2 py-3 text-center text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-32">
                    Nghiên cứu viên/Kỹ sư
                  </th>
                  <th className="px-2 py-3 text-center text-xs font-bold text-black uppercase tracking-wider w-32">
                    Trợ lý nghiên cứu/Kỹ
                    <br />
                    thuật viên
                  </th>
                </tr>
                <tr className="bg-gray-100">
                  <th className="px-2 py-2 text-center text-xs font-bold text-black border-r border-gray-200">
                    (1)
                  </th>
                  <th className="px-2 py-2 text-center text-xs font-bold text-black border-r border-gray-200">
                    (2)
                  </th>
                  <th className="px-2 py-2 text-center text-xs font-bold text-black border-r border-gray-200">
                    (3)
                  </th>
                  <th className="px-2 py-2 text-center text-xs font-bold text-black border-r border-gray-200">
                    (4)
                  </th>
                  <th className="px-2 py-2 text-center text-xs font-bold text-black border-r border-gray-200">
                    (5)
                  </th>
                  <th className="px-2 py-2 text-center text-xs font-bold text-black border-r border-gray-200">
                    (6)
                  </th>
                  <th className="px-2 py-2 text-center text-xs font-bold text-black">
                    (7)
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {mockData.map((item) => (
                  <tr key={item.id} className="hover:bg-gray-50">
                    <td className="px-2 py-4 whitespace-nowrap text-sm font-medium text-gray-900 border-r border-gray-200 text-center">
                      {item.stt}
                    </td>
                    <td className="px-2 py-4 text-sm text-gray-900 border-r border-gray-200">
                      {item.organizationName}
                    </td>
                    <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900 border-r border-gray-200 text-center">
                      {item.total}
                    </td>
                    <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900 border-r border-gray-200 text-center">
                      {item.seniorResearcher}
                    </td>
                    <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900 border-r border-gray-200 text-center">
                      {item.researcher}
                    </td>
                    <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900 border-r border-gray-200 text-center">
                      {item.researchEngineer}
                    </td>
                    <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900 text-center">
                      {item.assistantResearcher}
                    </td>
                  </tr>
                ))}
                {/* Totals Row */}
                <tr className="bg-gray-100 font-bold">
                  <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900 border-r border-gray-200 text-center"></td>
                  <td className="px-2 py-4 text-sm text-gray-900 border-r border-gray-200">
                    <strong>Tổng</strong>
                  </td>
                  <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900 border-r border-gray-200 text-center">
                    <strong>{totals.total}</strong>
                  </td>
                  <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900 border-r border-gray-200 text-center">
                    <strong>{totals.seniorResearcher}</strong>
                  </td>
                  <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900 border-r border-gray-200 text-center">
                    <strong>{totals.researcher}</strong>
                  </td>
                  <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900 border-r border-gray-200 text-center">
                    <strong>{totals.researchEngineer}</strong>
                  </td>
                  <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900 text-center">
                    <strong>{totals.assistantResearcher}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Pagination inside the table container */}
          <div className="flex justify-between items-center p-4 border-t border-gray-200">
            <div className="text-sm font-medium text-gray-700">
              Hiển thị <span className="font-bold">1</span> đến{" "}
              <select className="font-bold text-blue-600 border-none bg-transparent focus:ring-0 focus:outline-none text-sm">
                <option>10</option>
                <option>20</option>
                <option>50</option>
                <option>100</option>
              </select>{" "}
              trong <span className="font-bold">13</span> kết quả
            </div>
            <div className="flex space-x-2">
              <button className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50">
                &lt;
              </button>
              <button className="px-3 py-2 text-sm font-medium text-white bg-[#337ab7] border border-[#337ab7] rounded-md">
                1
              </button>
              <button className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50">
                &gt;
              </button>
            </div>
          </div>
        </div>
      </div>
    </PageShell>
  );
};

export default ResearchPositionSummary;
